export const LAST_ORDER_ID_KEY = "last-order-id";
export const LAST_ORDER_MENU_ID = "last-order-menu-id";
